
import ProgrammingArrows from "../../../assets/duotone/ProgrammingArrows.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ProgrammingArrowsIcon({ className, dataTestid = "ProgrammingArrowsIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ProgrammingArrows data-testid={dataTestid} className={classes} {...rest} />
  );
}
